import type { Note } from "@/core/types";

export function filterNotesByNoteType(notes: Note[]): Note[] {
  return notes.filter(
    (note) =>
      note.note_type == null ||
      note.note_type === "Video Consultation" ||
      note.note_type === "Check-in" ||
      note.note_type === "Care Coordination" ||
      note.note_type === "Initial Clinical Assessment" ||
      note.note_type === "Care Communication" ||
      note.note_type === "Care Management" ||
      note.note_type === "Case Management" ||
      note.note_type === "Advanced Care Activity",
  );
}
